import { useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { useIntl } from "react-intl";

import { ReactComponent as PlusCircleIcon } from "assets/images/iconsV2/plus-circle.svg";

type StopDividerProps = {
  onInsert: () => void;
  testId?: string;
};

export default function StopDivider({ onInsert, testId }: StopDividerProps) {
  const intl = useIntl();
  const addStopLabel = intl.formatMessage({ id: "request-form.schedule.addStop", defaultMessage: "Add stop" });
  const iconRef = useRef<HTMLSpanElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      <button
        type="button"
        className="rfv2-schedule-stop-divider"
        aria-label={addStopLabel}
        data-testid={testId}
        onClick={onInsert}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
      >
        <span className="rfv2-schedule-stop-divider__line" />
        <span ref={iconRef} className="rfv2-schedule-stop-divider__add">
          <PlusCircleIcon />
        </span>
      </button>
      <Overlay target={iconRef.current} show={showTooltip} placement="top">
        {(props) => (
          <Tooltip id="rfv2-schedule-insert-stop-tooltip" {...props}>
            {addStopLabel}
          </Tooltip>
        )}
      </Overlay>
    </>
  );
}
